let Observer = {
    bidListNo: '',              //商圈列表信息 - 无全部选项
    bidList: '',                //商圈列表信息
    gidList: '',                //本地缓存集团用户信息
    gid: '',                    //集团id
    userInfoAdd: '',            //本地缓存用户附加参数信息
    gidNodeId: '',              //集团nodeid
    lid: '',                    //业务线id
    bid: '',                    //商圈id
    platformType: '',           //登录类型  1GCRP  2CRP
    isTab: '',                   //切换类型  是否却换本地 1是 2否
}
export default Observer;



// WEBPACK FOOTER //
// ./src/applications/stores/observer.js